<div *ngIf="content?.hasError" class="form-alert" id="formAlertId">
  <idp-form-alert
    [message]="content?.errorMessage"
    [showCloseButton]="true"
    (closePopup)="onClosePop()"
  ></idp-form-alert>
</div>
<idp-login-header
  [ngClass]="{
    'login-header-margin':
      content.formAttributes.errorAlertBanner &&
      content.formAttributes.submitAttempt
  }"
  [loginHeaderContent]="content.pageContent.pageHeader"
  [machCore]="machCore"
  (triggerClose)="triggerClose.emit()"
></idp-login-header>

<ng-container
  *ngIf="
    content.formAttributes.submitAttempt &&
    content.formAttributes.errorAlertBanner &&
    content.formAttributes.errorCount
  "
>
  <idp-alert-warning
    #alertWaring
    (firstInvalidFieldFocusEvent)="onFocusFirstInvalidField()"
    [cntError]="content.formAttributes.errorCount"
    [errorMessage]="content.pageContent.errors.alertWarning"
  ></idp-alert-warning>
</ng-container>
<form
  [formGroup]="addSqaForm"
  id="addSqaForm"
  class="add-sqa"
  (ngSubmit)="onSubmit()"
>
  <div class="add-sqa__content">
    <div
      class="add-sqa__content__question_one"
      [ngClass]="{
        'add-sqa__content__focused':
          answerOneFocused ||
          (addSqaForm.value.answerOne?.value &&
            addSqaForm.value.answerOne?.value !== '')
      }"
    >
      <idp-dropdown
        [items]="content.pageContent.securityQuestionList"
        [placeholderText]="'Select One'"
        [topLabelText]="content.pageContent.question1Label"
        formControlName="questionOne"
        id="questionOne"
        (hasFocus)="onFocussedOut('questionOne')"
        (value)="onChangeDropdown($event)"
      ></idp-dropdown>
      <div
        *ngIf="showErrorMessageSqaQuestionOne"
        class="error-message__question_one"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.questionOneErrorMessage[
              questionOneFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
    <div class="add-sqa__content__answer_one">
      <idp-input
        [labelTxt]="content.pageContent.answer1Label"
        [ariaLabel]="content.pageContent.answer1Label"
        formControlName="answerOne"
        id="answerOne"
        (value)="onChange()"
        (focusOut)="onFocussedOut('answerOne'); onFocussedOutAnswerOne()"
        (isFocused)="onFocusedAnswerOne()"
      ></idp-input>
      <div
        class="error-message__answer_one"
        *ngIf="showErrorMessageSqaAnswerOne"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.answerOneErrorMessage[
              answerOneFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
    <div
      class="add-sqa__content__question_two"
      [ngClass]="{
        'add-sqa__content__focused':
          answerTwoFocused ||
          (addSqaForm.value.answerTwo?.value &&
            addSqaForm.value.answerTwo?.value !== '')
      }"
    >
      <idp-dropdown
        [items]="content.pageContent.securityQuestionList"
        [placeholderText]="'Select One'"
        [topLabelText]="content.pageContent.question2Label"
        formControlName="questionTwo"
        id="questionTwo"
        (hasFocus)="onFocussedOut('questionTwo')"
        (value)="onChangeDropdown($event)"
      ></idp-dropdown>
      <div
        *ngIf="showErrorMessageSqaQuestionTwo"
        class="error-message__question_two"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.questionTwoErrorMessage[
              questionTwoFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
    <div class="add-sqa__content__answer_two">
      <idp-input
        [labelTxt]="content.pageContent.answer2Label"
        [ariaLabel]="content.pageContent.answer2Label"
        formControlName="answerTwo"
        id="answerTwo"
        (value)="onChange()"
        (focusOut)="onFocussedOut('answerTwo'); onFocussedOutAnswerTwo()"
        (isFocused)="onFocusedAnswerTwo()"
      ></idp-input>
      <div
        *ngIf="showErrorMessageSqaAnswerTwo"
        class="error-message__answer_two"
      >
        <span
          class="errorMessageText"
          [innerHTML]="
            content.pageContent.errors.answerTwoErrorMessage[
              answerTwoFormControl().errors.error
            ]
          "
        ></span>
      </div>
    </div>
  </div>

  <div class="add-sqa__submit-btn">
    <idp-button
      [label]="content.pageContent.buttonLabel"
      [ariaLabel]="content.pageContent.buttonLabel"
      elementType="submit"
      [size]="'full-width'"
      [disabled]="content.formAttributes.disableActionButton"
    ></idp-button>
  </div>
</form>
